export default "__VITE_ASSET__5e6428e1__"